import { useMissionsTranslation } from '../../../../ui/hooks';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import { juvareColors } from '@juvare/common-web-ui/JuvareTheme';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const MissionContactPlaceholders = (props) => {
    const { contactName, contactPhone, contactEmail } = props;
    const { t } = useMissionsTranslation();
    return (React.createElement(TransparentBox, { "data-test": 'mission-contacts-transparent-box' },
        React.createElement(Box, null,
            React.createElement(Typography, { variant: 'subtitle2', sx: {
                    color: juvareColors.neutral['0-64p'],
                    wordWrap: 'break-word',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 1,
                    pb: 3,
                } },
                React.createElement(ContactSupportIcon, null),
                t('missions.missionContact')),
            React.createElement(Typography, { variant: 'h5', sx: { color: juvareColors.neutral[50], wordWrap: 'break-word' }, "data-test": 'mission-details-contact-name' }, contactName),
            React.createElement(Typography, { variant: 'body2', sx: { color: juvareColors.neutral['0-64p'], wordWrap: 'break-word' }, "data-test": 'mission-details-contact-phone' }, contactPhone && formatPhoneNumber(contactPhone)),
            React.createElement(Typography, { variant: 'body2', sx: { color: juvareColors.neutral['0-64p'], wordWrap: 'break-word' }, "data-test": 'mission-details-contact-email' }, contactEmail))));
};
